import { StepDirection } from 'scenes/common/types';
import {
  RetrieveFlowAction,
  RetrieveFunnelState,
} from 'scenes/retrieve/flows/types';

const flow = (
  funnelState: RetrieveFunnelState,
  action: RetrieveFlowAction
): Partial<RetrieveFunnelState> => {
  switch (action.direction) {
    case StepDirection.NextIfStepMatches:
      return funnelState;
    case StepDirection.Next:
      return funnelState;
    case StepDirection.Previous:
      return funnelState;
    case StepDirection.Beginning:
      return funnelState;
    case StepDirection.MoveFlow:
      return funnelState;
    case StepDirection.StayHere:
      return funnelState;
    case StepDirection.ApiResponse:
      return funnelState;
    default:
      throw new Error(`Unknown action direction '${action.direction}'`);
  }
};

const mergeFormState = (
  state: RetrieveFunnelState,
  action: RetrieveFlowAction
): RetrieveFunnelState => {
  if (action.direction === StepDirection.ApiResponse) {
    return {
      ...state,
      apiResponses: { ...state.apiResponses, ...action.apiResponses },
    };
  }
  return {
    ...state,
  };
};

export const targetPage = (
  retrieveQuoteState: RetrieveFunnelState,
  action: RetrieveFlowAction
): RetrieveFunnelState => {
  const result = {
    ...retrieveQuoteState,
    ...flow(retrieveQuoteState, action),
  };
  return result;
};

export const retrieveReducer = (
  state: RetrieveFunnelState,
  action: RetrieveFlowAction
): RetrieveFunnelState => {
  const mergeState = mergeFormState(state, action);

  const result = {
    ...mergeState,
    ...flow(mergeState, action),
  };

  // console.log('retrieveReducer state:', result);

  return result;
};
